import { DDComponent, setupTeliaLtFrontEnd } from '@telialt/utils/src/datadog/setup';

export const BRAND_BY_ICON_FILENAME = {
    Acer: 'acer_s.png',
    Apple: 'apple.png',
    Asus: 'asus_xs.png',
    CAT: 'cat.png',
    Google: 'google-pixel.png',
    'Google Pixel': 'google-pixel.png',
    HP: 'hp_s.png',
    Hisense: 'hisense_xs.png',
    Huawei: 'huawei_s.png',
    HyperX: 'hyperx_s.png',
    JBL: 'jbl_xs.png',
    LG: 'lg.svg',
    Lenovo: 'lenovo_xs.png',
    Microsoft: 'microsoft_s.png',
    'Microsoft Xbox': 'xbox_s.png',
    Xbox: 'xbox_s.png',
    Motorola: 'motorola.png',
    MSI: 'msi_s.png',
    Nintendo: 'nintendo_s.png',
    Nokia: 'nokia_xs.png',
    Nothing: 'nothing.png',
    One: 'oneplus.png',
    OnePlus: 'oneplus.png',
    'THE ONE': 'oneplus.png',
    POCO: 'poco.png',
    Panasonic: 'panasonic_xs.png',
    Philips: 'philips_xs.png',
    Samsung: 'samsung_xs.png',
    Sharp: 'sharp_xs.png',
    Sony: 'sony_xs.png',
    'Sony PlayStation': 'playstation_s.png',
    Xiaomi: 'xiaomi.png',
} as const;

export const getBrandIconFileName = (
    brandName: string,
    warnedMissingBrandCache: Set<string> = new Set(),
): string | undefined => {
    const brandIcon = BRAND_BY_ICON_FILENAME[brandName];
    if (!brandIcon && !warnedMissingBrandCache.has(brandName)) {
        const datadogLogs = setupTeliaLtFrontEnd();
        datadogLogs.logger.warn(`Icon file not found for brand "${brandName}"`, {
            component: DDComponent.EshopCategory,
        });
        warnedMissingBrandCache.add(brandName);
    }

    return brandIcon;
};
